import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { APP_INITIALIZER, LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule, Title } from "@angular/platform-browser";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { JoyrideModule } from "ngx-joyride";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { ErrorInterceptor } from "./core/helpers/error.interceptor";
import { JwtInterceptor } from "./core/helpers/jwt.interceptor";
import { LayoutModule } from "./layout/layout.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { TranslateModule, TranslateLoader, TranslateService } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import localePt from "@angular/common/locales/pt-PT";
import localeAU from '@angular/common/locales/en-AU';
import { registerLocaleData } from "@angular/common";
import { SharedModule } from "./shared/shared.module";
import { AuthenticationService } from "./core/service/auth.service";
import { first } from "rxjs/operators";
import { Observable } from "rxjs";
import { NotificationScreenModule } from './pages/notification-screen/notification-screen.module';
import { BoardMainScreenService } from "./pages/projects/board/board-main-screen/board-main-screen.service";
import { SoapService } from "./core/service/soap.service";
import { DialogModule } from "primeng/dialog";

registerLocaleData(localePt, 'pt');
registerLocaleData(localeAU, 'en');

function initializeApp(authService: AuthenticationService): () => Observable<any> {
  return () => {
    return authService.initialRefreshToken().pipe(first());
  }
}

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    DialogModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
      extend: true,
    }),
    JoyrideModule.forRoot(),
    SweetAlert2Module.forRoot(),
    AppRoutingModule,
    LayoutModule,
    NotificationScreenModule,
  ],
  providers: [
    AuthenticationService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [AuthenticationService]
    },
    TranslateService,
    {
      provide: LOCALE_ID,
      useValue: 'en',
    },
    Title,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    SoapService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {


}
